/**
 * Split Promo Banner — initializes a Swiper carousel per section instance.
 * Reads its config from data-* attributes set in split-promo-banner.liquid
 * so every setting in the theme editor maps directly here.
 */
(function () {
  function initSplitPromo(root) {
    if (!root || root.dataset.splitPromoInitialized === 'true') return;

    var swiperEl = root.querySelector('[data-split-promo-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var perViewMobile = parseInt(root.dataset.perViewMobile, 10) || 1;
    var perViewDesktop = parseInt(root.dataset.perViewDesktop, 10) || 2;
    var gap = parseInt(root.dataset.gap, 10) || 20;
    var autoplayEnabled = root.dataset.autoplayEnabled === 'true';
    var autoplayDelay = parseInt(root.dataset.autoplayDelay, 10) || 5000;
    var pauseOnHover = root.dataset.pauseHover === 'true';
    var loopEnabled = root.dataset.loop === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 600;

    var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    // Swiper needs enough slides to loop cleanly with the given slidesPerView.
    var canLoop = loopEnabled && slideCount > perViewDesktop;

    var config = {
      slidesPerView: perViewMobile,
      spaceBetween: gap,
      loop: canLoop,
      speed: speed,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        750: {
          slidesPerView: perViewDesktop,
          spaceBetween: gap
        }
      }
    };

    if (autoplayEnabled && slideCount > 1) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover
      };
    }

    var swiperInstance = new Swiper(swiperEl, config);

    root.dataset.splitPromoInitialized = 'true';
    root._splitPromoSwiper = swiperInstance;
  }

  function initAll() {
    document.querySelectorAll('[data-split-promo]').forEach(initSplitPromo);
  }

  // Standard storefront load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a new section instance is added, e.g. Shopify OS 2.0
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-split-promo]');
    if (root) initSplitPromo(root);
  });

  // Destroy the swiper instance cleanly when the section is removed/reordered
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-split-promo]');
    if (root && root._splitPromoSwiper) {
      root._splitPromoSwiper.destroy(true, true);
      root.dataset.splitPromoInitialized = 'false';
    }
  });
})();